/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Lease, LeaseStatus } from "../../../models/lease.model"
import { Owner } from "../../../models/owner.model"
import { Payment } from "../../../models/payment.model"
import { Property } from "../../../models/property.model"
import { RentIncrease } from "../../../models/rent-increase.model"
import { Tenant } from "../../../models/tenant.model"
import { Unit } from "../../../models/unit.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { LEASE_ENDPOINT } from "../lease.endpoint"

let leaseCollection: CollectionQuery
let leaseCountCollection: CollectionQuery
let ownersOfLeaseCollection: CollectionQuery
let propertiesOfLeaseCollection: CollectionQuery
let tenantsOfLeaseCollection: CollectionQuery
let unitsOfLeaseCollection: CollectionQuery
let archivedLeaseCollection: CollectionQuery

let rentIncreaseCollection: CollectionQuery
let archivedRentIncreaseCollection: CollectionQuery
const rentIncreaseQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getRentIncrease: builder.query<RentIncrease, string>({
      query: (id: string) => ({
        url: `${LEASE_ENDPOINT.detailRentIncrease}/${id}`,
        method: "get",
      }),
      providesTags: ["Rent Increase"],
    }),

    getRentIncreases: builder.query<Collection<RentIncrease>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${LEASE_ENDPOINT.listRentIncrease}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Rent Increases"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   rentIncreaseCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createRentIncrease: builder.mutation<RentIncrease, RentIncrease>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.createRentIncrease}`,
        method: "post",
        data: newData,
        permissions: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   rentIncreaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    createBulkRentIncrease: builder.mutation<RentIncrease, any>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.createBulkRentIncrease}`,
        method: "post",
        data: newData,
        permissions: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   rentIncreaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateRentIncrease: builder.mutation<RentIncrease, RentIncrease>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.updateRentIncrease}`,
        method: "put",
        data: newData,
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases", "Rent Increase"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   rentIncreaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((lease) => {
            //           if (lease.id === data.id) return data
            //           else {
            //             return lease
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    changeRentIncreaseStatus: builder.mutation<
      RentIncrease,
      { id: string; status: string }
    >({
      query: (newData: { id: string; status: string }) => ({
        url: `${LEASE_ENDPOINT.updateRentIncrease}`,
        method: "post",
        data: newData,
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   rentIncreaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((lease) => {
            //           if (lease.id === data.id) return data
            //           else {
            //             return lease
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    deleteRentIncrease: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${LEASE_ENDPOINT.deleteRentIncrease}/${id}`,
        method: "delete",
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   rentIncreaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (rentIncrease) => rentIncrease.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    
  }),
  overrideExisting: true,
})
export const {
  useLazyGetRentIncreaseQuery,
  useLazyGetRentIncreasesQuery,
  useUpdateRentIncreaseMutation,
  useCreateRentIncreaseMutation,
  useDeleteRentIncreaseMutation,
  useChangeRentIncreaseStatusMutation,
  useCreateBulkRentIncreaseMutation
} = rentIncreaseQuery
